import React from 'react'

import { useCollapse } from 'react-collapsed'


function ShowMore({children, className, ...props}) {

  const {
    getCollapseProps,
    getToggleProps,
    isExpanded
  } = useCollapse({
    collapsedHeight: 180,
  })

  const ShowMore = <strong style={{ display : 'block'}}>{`Show more ›`}</strong>
  const ShowLess = <strong>{`‹ Show less`}</strong>

  return (
    <div className={className}>

      <div {...getCollapseProps()}>
        {children}
      </div>

      <button className={`ui button secondary small`} {...getToggleProps()}>
        {isExpanded
          ? ShowLess
          : ShowMore
        }
      </button>

    </div>
  )
}

export default ShowMore
